import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-pharamcy-nickname',
  imports: [ReactiveFormsModule],
  templateUrl: './pharamcy-nickname.html',
  styleUrl: './pharamcy-nickname.scss',
  standalone: true,
})
export class PharamcyNickname {
  pharmacyForm = input.required<FormGroup>();
  // pharmacyControlName = input.required<string>();
}
